// extracted by mini-css-extract-plugin
export var active = "typeSelector-module--active---Sm-o";
export var arrow = "typeSelector-module--arrow--TUNPh";
export var container = "typeSelector-module--container--zVKXv";
export var open = "typeSelector-module--open--nzsgk";
export var placeholder = "typeSelector-module--placeholder--njOxM";
export var remove = "typeSelector-module--remove--rcD0i";
export var select = "typeSelector-module--select--BXnT9";
export var type = "typeSelector-module--type--0hnbK";
export var typeFilter = "typeSelector-module--typeFilter--C0thF";